import React, { useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import AnalyticsNavigation from "./components/AnalyticsNavigation";
import config from "../../config";
import { fetchData } from "../../services/apiServices";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
} from "recharts";

const AnalyticsDashboard = () => {
  const coins = [
    { name: "BNB - BEP20", coin: 0, token: 0 },
    { name: "ETH - ERC20", coin: 0, token: 0 },
    { name: "TRX - TRC20", coin: 0, token: 0 },
  ];

  const [dashboardData, setDashboardData] = React.useState(null);
  const [dashboardData1, setDashboardData1] = React.useState(null);
  const [packData, setPackData] = useState();
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  console.log("packData", packData);

  React.useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const response = await fetchData("api/v2/admin/auth/dashboard/stats");

        if (!response.status) {
          throw new Error("Failed to fetch dashboard data");
        }

        if (response.status) {
          setDashboardData(response.data);
        } else {
          throw new Error(response.message || "Failed to fetch dashboard data");
        }
      } catch (err) {
        setError(err.message);
        console.error("Error fetching dashboard data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  React.useEffect(() => {
    const fetchDashboardData1 = async () => {
      try {
        setLoading(true);

        const response = await fetchData("api/v2/admin/auth/dashboard/stats");

        if (!response.status) {
          throw new Error("Failed to fetch dashboard data");
        }

        if (response.status) {
          setDashboardData1(response.data);
        } else {
          throw new Error(response.message || "Failed to fetch dashboard data");
        }
      } catch (err) {
        setError(err.message);

        console.error("Error fetching dashboard data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData1();
  }, []);

  React.useEffect(() => {
    const fetchPackData = async () => {
      try {
        setLoading(true);

        const response = await fetchData("api/v2/admin/auth/packs-stats");

        if (!response.status) {
          throw new Error("Failed to fetch dashboard data");
        }

        if (response.status) {
          setPackData(response.data);
        } else {
          throw new Error(response.message || "Failed to fetch dashboard data");
        }
      } catch (err) {
        setError(err.message);

        console.error("Error fetching dashboard data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPackData();
  }, []);

  const financialData = dashboardData
    ? [
        { name: "Bets", value: dashboardData.totalBets },
        { name: "Profit", value: dashboardData.totalProfit },
        { name: "Loss", value: dashboardData.totalLoss },
        { name: "Commission", value: dashboardData.totalCommission },
      ]
    : [];

  const userActivityData = dashboardData1
    ? [
        { name: "Users", value: dashboardData1.totalusers },
        { name: "Pending Deposits", value: dashboardData1.toalpendingdeposit },
        {
          name: "Pending Withdraws",
          value: dashboardData1.toalpendingwithdraw,
        },
      ]
    : [];

  // Add new data for the requested metrics
  const metricsData = dashboardData1
    ? [
        { name: "Total Packs", value: dashboardData1.totalPacks || 0 },
        { name: "Total Volume", value: dashboardData1.totalVolume || 0 },
        {
          name: "Total Users",
          value: dashboardData1.totalUsers || dashboardData1.totalusers || 0,
        },
        { name: "Live Users", value: dashboardData1.liveUsers || 0 },
        { name: "Total Items", value: dashboardData1.totalItems || 0 },
      ]
    : [];

  const COLORS = ["#556ee6", "#34c38f", "#f46a6a", "#f1b44c", "#50a5f1"];

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Analytics" breadcrumbItem="Dashboard" />
        <AnalyticsNavigation activeTab="dashboard" />

        {loading && (
          <div className="text-center mt-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        {error && (
          <Card>
            <CardBody>
              <div className="alert alert-danger mb-0">
                Error loading dashboard data: {error}
              </div>
            </CardBody>
          </Card>
        )}

        {/* NEW METRICS SECTION - Total Packs, Total Volume, etc. */}
        <div className="row mt-2">
          {/* Total Packs */}
          <div className="col-xl-2 col-md-4 col-sm-6">
            <Card>
              <CardBody>
                <div className="d-flex">
                  <div className="flex-grow-1">
                    <h4 className="fw-medium">
                      {dashboardData1?.totalPacks?.toLocaleString() || 0}
                    </h4>
                    <p className="text-muted mb-0">Total Packs</p>
                  </div>
                  <div className="avatar-sm rounded-circle bg-purple align-self-center mini-stat-icon">
                    <span className="avatar-title rounded-circle bg-purple">
                      <i className="ri-box-3-line font-size-24"></i>
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>

          {/* Total Volume */}
          <div className="col-xl-2 col-md-4 col-sm-6">
            <Card>
              <CardBody>
                <div className="d-flex">
                  <div className="flex-grow-1">
                    <h4 className="fw-medium text-success">
                      ₹ {dashboardData1?.totalVolume?.toLocaleString() || 0}
                    </h4>
                    <p className="text-muted mb-0">Total Volume</p>
                  </div>
                  <div className="avatar-sm rounded-circle bg-success align-self-center mini-stat-icon">
                    <span className="avatar-title rounded-circle bg-success">
                      <i className="ri-line-chart-line font-size-24"></i>
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>

          {/* Total Users */}
          <div className="col-xl-2 col-md-4 col-sm-6">
            <Card>
              <CardBody>
                <div className="d-flex">
                  <div className="flex-grow-1">
                    <h4 className="fw-medium text-primary">
                      {dashboardData1?.totalUsers?.toLocaleString() ||
                        dashboardData1?.totalusers?.toLocaleString() ||
                        0}
                    </h4>
                    <p className="text-muted mb-0">Total Users</p>
                  </div>
                  <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                    <span className="avatar-title rounded-circle bg-primary">
                      <i className="ri-user-3-line font-size-24"></i>
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>

          {/* Live Users */}
          <div className="col-xl-2 col-md-4 col-sm-6">
            <Card>
              <CardBody>
                <div className="d-flex">
                  <div className="flex-grow-1">
                    <h4 className="fw-medium text-info">
                      {dashboardData1?.liveUsers?.toLocaleString() || 0}
                    </h4>
                    <p className="text-muted mb-0">Live Users</p>
                  </div>
                  <div className="avatar-sm rounded-circle bg-info align-self-center mini-stat-icon">
                    <span className="avatar-title rounded-circle bg-info">
                      <i className="ri-user-heart-line font-size-24"></i>
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>

          {/* Total Items */}
          <div className="col-xl-2 col-md-4 col-sm-6">
            <Card>
              <CardBody>
                <div className="d-flex">
                  <div className="flex-grow-1">
                    <h4 className="fw-medium text-warning">
                      {dashboardData1?.totalItems?.toLocaleString() || 0}
                    </h4>
                    <p className="text-muted mb-0">Total Items</p>
                  </div>
                  <div className="avatar-sm rounded-circle bg-warning align-self-center mini-stat-icon">
                    <span className="avatar-title rounded-circle bg-warning">
                      <i className="ri-archive-line font-size-24"></i>
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>

        {/* Original dashboardData section */}
        {packData && (
          <div className="row mt-4">
            <div className="col-xl-3 col-md-6">
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <h4 className="fw-medium">
                        {packData.totalItems?.toLocaleString() || 0}
                      </h4>
                      <p className="text-muted mb-0">Total items</p>
                    </div>
                    <div className="avatar-sm rounded-circle bg-info align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-info">
                        <i className="ri-gamepad-line font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className="col-xl-3 col-md-6">
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <h4 className="fw-medium text-success">
                        ₹ {packData.totalItemsInPacks?.toLocaleString() || 0}
                      </h4>
                      <p className="text-muted mb-0">Total items in Pack</p>
                    </div>
                    <div className="avatar-sm rounded-circle bg-success align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-success">
                        <i className="ri-arrow-up-circle-line font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className="col-xl-3 col-md-6">
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <h4 className="fw-medium text-danger">
                        ₹ {packData.totalPacks?.toLocaleString() || 0}
                      </h4>
                      <p className="text-muted mb-0">Total Packs</p>
                    </div>
                    <div className="avatar-sm rounded-circle bg-danger align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-danger">
                        <i className="ri-arrow-down-circle-line font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className="col-xl-3 col-md-6">
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <h4 className="fw-medium text-warning">
                        ₹ {packData.averageItemsPerPack?.toLocaleString() || 0}
                      </h4>
                      <p className="text-muted mb-0">Average Items Per Pack</p>
                    </div>
                    <div className="avatar-sm rounded-circle bg-warning align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-warning">
                        <i className="ri-percent-line font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        )}

        {/* Original dashboardData1 section */}
        {dashboardData1 && (
          <div className="row mt-4">
            {/* Total Users (from original section) */}
            <div className="col-xl-3 col-md-6">
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <h4 className="fw-medium">
                        {dashboardData1.totalusers?.toLocaleString() || 0}
                      </h4>
                      <p className="text-muted mb-0">Total Users</p>
                    </div>
                    <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-primary">
                        <i className="ri-user-3-line font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            {/* Pending Deposits */}
            <div className="col-xl-3 col-md-6">
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <h4 className="fw-medium text-warning">
                        {dashboardData1.toalpendingdeposit?.toLocaleString() ||
                          0}
                      </h4>
                      <p className="text-muted mb-0">Pending Deposits</p>
                    </div>
                    <div className="avatar-sm rounded-circle bg-warning align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-warning">
                        <i className="ri-bank-card-line font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            {/* Pending Withdraws */}
            <div className="col-xl-3 col-md-6">
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <h4 className="fw-medium text-danger">
                        {dashboardData1.toalpendingwithdraw?.toLocaleString() ||
                          0}
                      </h4>
                      <p className="text-muted mb-0">Pending Withdrawals</p>
                    </div>
                    <div className="avatar-sm rounded-circle bg-danger align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-danger">
                        <i className="ri-wallet-3-line font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            {/* Additional metrics if your API returns them */}
            {dashboardData1.activeUsers && (
              <div className="col-xl-3 col-md-6">
                <Card>
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <h4 className="fw-medium text-success">
                          {dashboardData1.activeUsers?.toLocaleString() || 0}
                        </h4>
                        <p className="text-muted mb-0">Active Users</p>
                      </div>
                      <div className="avatar-sm rounded-circle bg-success align-self-center mini-stat-icon">
                        <span className="avatar-title rounded-circle bg-success">
                          <i className="ri-user-star-line font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            )}
          </div>
        )}

        {/* Charts Section */}
        <div className="row mt-4">
          {/* Financial Overview */}
          <div className="col-xl-6">
            <Card>
              <CardBody>
                <h5 className="mb-4">Platform Financial Overview</h5>
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={financialData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="value" fill="#556ee6" radius={[6, 6, 0, 0]} />
                  </BarChart>
                </ResponsiveContainer>
              </CardBody>
            </Card>
          </div>

          {/* User & Wallet Activity */}
          <div className="col-xl-6">
            <Card>
              <CardBody>
                <h5 className="mb-4">User & Wallet Activity</h5>
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={userActivityData}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="50%"
                      outerRadius={100}
                      label>
                      {userActivityData.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}
                    </Pie>
                    <Tooltip />
                    <Legend />
                  </PieChart>
                </ResponsiveContainer>
              </CardBody>
            </Card>
          </div>
        </div>

        {/* Optional: Add a chart for the new metrics */}
        {metricsData.some((item) => item.value > 0) && (
          <div className="row mt-4">
            <div className="col-xl-12">
              <Card>
                <CardBody>
                  <h5 className="mb-4">Platform Metrics Overview</h5>
                  <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={metricsData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip formatter={(value) => value.toLocaleString()} />
                      <Bar
                        dataKey="value"
                        fill="#34c38f"
                        radius={[6, 6, 0, 0]}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </CardBody>
              </Card>
            </div>
          </div>
        )}
      </Container>
    </div>
  );
};

export default AnalyticsDashboard;
